import type { GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { dehydrate, QueryClient } from "@tanstack/react-query";
import { getDContactUs, getDLanguages, getDSetting } from "api/developmentResearchUser";
import { ContactUs } from "components/ClinicalCenter/ContactUs";
import { TIME_REVALIDATE } from "config/info";

const ContactUsPage: NextPage = () => {
  return (
    <>
      <ContactUs />
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const locale = context.locale as string;
  const queryClient = new QueryClient();

  const requests = [
    queryClient.prefetchQuery(["getDLanguages", locale], () => getDLanguages(locale)),
    queryClient.prefetchQuery(["getDSetting", locale], () => getDSetting(locale)),
    queryClient.prefetchQuery(["getDContactUs", locale], () => getDContactUs(locale)),
  ];

  await Promise.all(requests);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      ...(await serverSideTranslations(locale || "", ["common"])),
    },
    revalidate: TIME_REVALIDATE,
  };
};

export default ContactUsPage;
